// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class BaseHomeTab {
    public static readonly pageId = 'home-tab';
}

export default BaseHomeTab;
